import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-account-section-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="bg-surface rounded-3xl border border-border-subtle p-6 sm:p-8 shadow-md antialiased">
      <h2
        class="text-sm font-black text-text-primary uppercase tracking-widest font-mono flex items-center gap-2 mb-6"
      >
        <i [class]="iconClass + ' text-primary'"></i>
        {{ title }}
      </h2>
      <div class="w-full text-text-secondary">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class AccountSectionCardComponent {
  @Input() title: string = '';
  @Input() iconClass: string = '';
}
